"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const standard_1 = require("react-hook-schema/standard");
const base_1 = require("../base");
const objectSchemaComponent = (0, standard_1.createObjectSchemaComponent)(() => base_1.Field);
exports.default = objectSchemaComponent;
